
    import './styles.scoped.css';
    export default {
  "body-cell": "awsui_body-cell_c6tup_14kzj_99",
  "sticky-cell": "awsui_sticky-cell_c6tup_14kzj_133",
  "body-cell-wrap": "awsui_body-cell-wrap_c6tup_14kzj_136",
  "is-visual-refresh": "awsui_is-visual-refresh_c6tup_14kzj_148",
  "has-striped-rows": "awsui_has-striped-rows_c6tup_14kzj_160",
  "body-cell-edit-active": "awsui_body-cell-edit-active_c6tup_14kzj_163",
  "body-cell-editable": "awsui_body-cell-editable_c6tup_14kzj_163",
  "has-striped-rows-sticky-cell-pad-left": "awsui_has-striped-rows-sticky-cell-pad-left_c6tup_14kzj_169",
  "has-selection": "awsui_has-selection_c6tup_14kzj_172",
  "body-cell-first-row": "awsui_body-cell-first-row_c6tup_14kzj_178",
  "body-cell-last-row": "awsui_body-cell-last-row_c6tup_14kzj_181",
  "body-cell-selected": "awsui_body-cell-selected_c6tup_14kzj_181",
  "has-footer": "awsui_has-footer_c6tup_14kzj_181",
  "body-cell-shaded": "awsui_body-cell-shaded_c6tup_14kzj_191",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_c6tup_14kzj_225",
  "sticky-cell-last-right": "awsui_sticky-cell-last-right_c6tup_14kzj_242",
  "sticky-cell-last-left": "awsui_sticky-cell-last-left_c6tup_14kzj_246",
  "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_14kzj_269",
  "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_14kzj_273",
  "body-cell-editor-wrapper": "awsui_body-cell-editor-wrapper_c6tup_14kzj_297",
  "body-cell-success": "awsui_body-cell-success_c6tup_14kzj_304",
  "body-cell-editor": "awsui_body-cell-editor_c6tup_14kzj_297",
  "body-cell-editor-disabled": "awsui_body-cell-editor-disabled_c6tup_14kzj_331",
  "body-cell-editor-form": "awsui_body-cell-editor-form_c6tup_14kzj_340",
  "body-cell-editor-row": "awsui_body-cell-editor-row_c6tup_14kzj_350",
  "body-cell-editor-controls": "awsui_body-cell-editor-controls_c6tup_14kzj_360",
  "body-cell-interactive": "awsui_body-cell-interactive_c6tup_14kzj_381",
  "body-cell-edit-disabled-popover": "awsui_body-cell-edit-disabled-popover_c6tup_14kzj_423",
  "body-cell-has-success": "awsui_body-cell-has-success_c6tup_14kzj_427"
};
  